import * as React from 'react';
import { safeJsonParse, createFetchOptions } from '../util';

interface IErrorPageState {
  error?: {
    status: string;
    message: string;
  };
}

export default class ErrorPage extends React.Component<void, IErrorPageState> {
  constructor(props?: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    fetch('http://localhost:8080/api/oups', createFetchOptions())
      .then(response => safeJsonParse(response))
      .then(error => this.setState({error}))
      .catch(err => {
        console.error('Error loading error page:', err);
        this.setState({ error: { status: 'Error', message: 'Failed to load error details' } });
      });
  }

  render() {
    const { error } = this.state;

    return <span>
      <img src='/images/pets.png' />

      <h2>Something happened...</h2>
      { error ?
        <span>
          <p><b>Status:</b> {error.status}</p>
          <p><b>Message:</b> {error.message}</p>
        </span>
        :
        <p><b>Unkown error</b></p>
      }
    </span>;
  }
}
